import {Component, Input, Output, EventEmitter} from '@angular/core';

// Path: src/app/components/buttons/button/button.component.ts
@Component({
  selector: 'mwo-edit-planning',
  templateUrl: './edit-planning.component.html',
  styleUrls: ['./edit-planning.component.scss'],
})
export class EditPlanningComponent {

  days = [
    { completed: false, disabled: false, name: 'monday' },
    { completed: false, disabled: false, name: 'tuesday' },
    { completed: false, disabled: false, name: 'wednesday' },
    { completed: false, disabled: false, name: 'thursday' },
    { completed: false, disabled: false, name: 'friday' },
    { completed: false, disabled: false, name: 'saturday' },
    { completed: false, disabled: false, name: 'sunday' }
  ];


  private _activeDayIndex: number;
  allComplete: boolean = false;

  @Input()
  set activeDayIndex(value: number) {
    this._activeDayIndex = value;
    this.setDaysConfigurationToDefault();
    this.days[this._activeDayIndex].disabled = true;
    this.days[this._activeDayIndex].completed = true;
  }
  get activeDayIndex(): number {
    return this._activeDayIndex;
  }

  // output every time the user checks a day a list of days where completed equals true
  @Output() onDayChecked = new EventEmitter<Array<number>>();

  constructor() { }

  handleEmit() {
    this.onDayChecked.emit(this.days.map((day, index) => day.completed ? index : -1).filter(index => index !== -1));
  }
  setAll(completed: boolean) {
    this.days.forEach((day, index) => {
      if (!day.disabled && index !== this.activeDayIndex) {
        day.completed = completed;
      }
    });
    this.handleEmit();
  }

  setDaysConfigurationToDefault() {
    this.days = [
      { completed: false, disabled: false, name: 'monday' },
      { completed: false, disabled: false, name: 'tuesday' },
      { completed: false, disabled: false, name: 'wednesday' },
      { completed: false, disabled: false, name: 'thursday' },
      { completed: false, disabled: false, name: 'friday' },
      { completed: false, disabled: false, name: 'saturday' },
      { completed: false, disabled: false, name: 'sunday' }
    ];
  }

}
